
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { Mail, MapPin, Phone } from 'react-feather';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Contact form submitted:', formData);
    setShowAlert(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setShowAlert(false), 5000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page py-5">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-4 fw-bold mb-3">Contact Us</h1>
            <p className="lead text-muted">
              Get in touch with our team. We're here to help you with any questions or support you need.
            </p>
          </Col>
        </Row>

        <Row>
          <Col lg={8} className="mx-auto">
            {showAlert && (
              <Alert variant="success" className="mb-4">
                Thank you for your message! We'll get back to you soon.
              </Alert>
            )}

            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="Your full name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="your.email@example.com"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label>Subject *</Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder="What is this regarding?"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Message *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      placeholder="Tell us more about your inquiry..."
                    />
                  </Form.Group>

                  <div className="d-grid">
                    <Button
                      type="submit"
                      size="lg"
                      style={{ backgroundColor: '#6C63FF', borderColor: '#6C63FF' }}
                    >
                      Send Message
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={4} className="text-center mb-4">
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <Mail size={48} className="text-primary mb-3" />
                <h5 className="fw-bold">Email Us</h5>
                <p className="text-muted mb-0">
                  <a href="mailto:info@deviofy.com" className="text-decoration-none">
                    info@deviofy.com
                  </a>
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="text-center mb-4">
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <MapPin size={48} className="text-primary mb-3" />
                <h5 className="fw-bold">Visit Us</h5>
                <p className="text-muted mb-0">
                  DSO-THUB, Dubai Digital Park<br />
                  Dubai Silicon Oasis, Building A2<br />
                  Dubai, UAE
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="text-center mb-4">
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <Phone size={48} className="text-primary mb-3" />
                <h5 className="fw-bold">Support</h5>
                <p className="text-muted mb-0">
                  24/7 customer support<br />
                  Response within 24 hours
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactPage;
